import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'd3-callout-box',
  templateUrl: './callout-box.component.html',
  styleUrls: ['./callout-box.component.scss'],
})
export class D3CalloutBoxComponent {
  @Input() icon = '';
  @Input() title = '';
  @Input() maxWidth = 'auto';
  @Input() removeTopMargin = false;
}
